import _ from "underscore";
import DriveView from "../../DriveView";
import { dispatcher, DispatcherEvents } from "../../utils/dispatcher";
import { PageLevel } from "../../store/mobile/types";
import Messages from "../../model/Messages";
import Message from "../../model/Message";
import { getCurrentVehicle } from "../../utils/device";
import { handleApi } from "../../utils/error";
import { hide, show } from "../../utils/vanilla";
import pageHTML from "./events.tmpl";
import Notifications, { NEW_EVENT_NOTIFICATION_STRING } from "../../utils/notifications";
import { filterMessages, groupMessagesByDate } from "../../modules/core/notifications/events/helpers/viewHelpers";

export default class EventsView extends DriveView<any> {

    protected strings = [NEW_EVENT_NOTIFICATION_STRING];
    private readonly template = _.template(pageHTML);
    private readonly messages: Messages;
    private readonly currentVehicle;
    private readonly deviceId: string;
    private readonly currentUser: DeepReadonlyObject<IUser> | null;
    private readonly currentUserId: string | undefined;

    constructor (options) {
        super(options, {
            title: "Events",
            activeSection: "notifications",
            activeView: "inbox",
            pageLevel: PageLevel.ONE
        });

        this.currentUser = this.app.userService.getCurrentUser();
        this.currentUserId = this.currentUser?.id;
        this.messages = new Messages(this.app.store, this.currentUserId);
        this.messages.fetch();
        this.currentVehicle = getCurrentVehicle();
        this.deviceId = this.currentVehicle.id;

        this.listenTo(dispatcher, DispatcherEvents.SyncMessages, () => {
            this.render();
        });
    }

    /* eslint-disable @typescript-eslint/unbound-method */
    events() {
        return {
            "click .message-date__header": this.dateHeaderClick
        } as Backbone.EventsHash;
    }
    /* eslint-enable @typescript-eslint/unbound-method */

    render () {
        let renderContent = (msgs: Message[]) => {
            this.display(this.template({
                messageGroups: groupMessagesByDate(msgs)
            })).then(() => {
                this.app.setFullWidth(true);
            })
            .catch(handleApi);
        };

        let allMessages = this.messages.getMessages({
            sortAscending: false
        });
        let filteredMsgs = filterMessages(allMessages, this.deviceId);

        if (this.currentUserId) {
            let unreadEventsCount = filteredMsgs.filter(msg => !msg.read).length;
            Notifications.updateUnreadEventsNotification(unreadEventsCount, this.currentUserId, this.getString(NEW_EVENT_NOTIFICATION_STRING));
        }

        renderContent(filteredMsgs);
        return this;
    }

    remove() {
        this.app.setFullWidth(false);
        super.remove();
        return this;
    }

    dateHeaderClick (e) {
        let date = e.currentTarget.id;
        let eventsList = document.getElementById(`notification-group-${ date }`);
        if (eventsList) {
            if (eventsList.style.display === "") {
                hide(eventsList);
            } else {
                show(eventsList);
            }
        }
    }
}